import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class ContentSourceRole extends BaseEntityModel {
  id?: number;
  contentSourceId?: number;
  role?: string;

  constructor(model: Partial<ContentSourceRole> = {}) {
    super(model);

    this.id = model.id;
    this.contentSourceId = model.contentSourceId;
    this.role = model.role;
  }
}
